export const fullWidthDialog = {
  "& .MuiDialog-paper": {
    width: { xs: "100%" },
    margin: { xs: 0 },
  },
};
